import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { Conception_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { ConceptionTable } from './Tables';
import {  CycleLengthComponent } from './Component';
import SharedHelmet from "../Helmet";
const TITLE = 'Conception Date Calculator - Calculate Fertility Days Easily and Accurately';
const DESCRIPTION = 'Pregnancy and Birth Calculator, enter the date of your last period to calculate the expected pregnancy date, pregnancy duration, and ovulation days to determine fertility days and chances of pregnancy.';
const KEYWORDS = 'Conception date calculation, Fertility timing, Pregnancy days calculation, Expected conception date, Pregnancy period calculator, Pregnancy days calculator, Determine conception date, Fertility timing calculator, Conception analysis, Pregnancy calendar, Pregnancy calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/conception/';
const apiEndpoint = `${SERVER_URL}/${Conception_EndPoint}`;
function ConceptionCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateConception = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data["result"]);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}> {TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Conception Timing Calculator estimates the range of days in which a woman is most likely to be in her most fertile period, in addition to the corresponding due date based on the average menstrual cycle of the woman.
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Conception Timing Calculator
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>First day</strong> of the last menstrual period
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average time between cycles
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">days</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateConception} disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Calculate'
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter all fields correctly. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <ConceptionTable result={result}></ConceptionTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Conception Timing Calculator:</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>
                                    <u><b>The Fertile Window</b></u>
                                </h2>
                                <p>
                                    The fertile window is a period of three days during which a woman has the highest likelihood of getting pregnant. Conception is typically defined as the start of pregnancy when the egg is fertilized. This can occur either through laboratory fertilization or through intimate relations. In the case of intimate relations, sperm can remain viable inside a woman's body for up to 5 days (up to 7 days in some cases). Therefore, when trying to conceive, regular intimate relations in the 5 days leading up to ovulation and on the day of ovulation itself can increase the chances of successful conception. This is known as the fertile window. Furthermore, studies have shown that within this window, the last 3 days are the most fertile, and intimate relations during this period can lead to pregnancy in approximately 30% of cases.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>
                                    <u><b>Love and Conception</b></u>
                                </h2>
                                <p>
                                    The desire for parenthood is about the love for your partner and the child you will nurture. Regardless of how deep this desire is for most couples, life often gets in the way. We feel stress and anxiety due to work and spend most of our time dealing with daily obligations and household chores. Consequently, we may not have enough time or may not be in the mood for intimate activities as much as we might want.
                                    However, the first thing to know when trying to conceive is that regular intimate relations with your partner are the best preparation of all. When trying to conceive, you should engage in regular intimate relations—at least two to three times a week—even when you don't necessarily believe you are fertile or close to ovulation.
                                    Regular intimate relations prepare a woman's body for conception and elevate the associated hormonal levels. Decreased fertility is also associated with a decreased sense of sexuality. Enhancing your lifestyle and relationships improves your chances of pregnancy.
                                    Regular intimate relations also create more favorable conditions in the vagina. Having high-quality cervical mucus (similar to egg white) enhances fertility by creating more favorable conditions in the vagina that help protect and extend the effective life of sperm, thus extending the fertile window.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>
                                    <u><b>Making the Fertile Window Work for You</b></u>
                                </h2>
                                After establishing a pattern of regular intimate relations, it's important to identify those few days before ovulation, including the day of ovulation itself. Determining this "window" significantly increases your chances of conception. The aforementioned conception calculator can assist you in tracking your personal biological cycle and help you identify your specific fertile window. To use the calculator, record the first day of your current cycle, then record the length of your cycle up to the next cycle. Finally,
                                <hr />
                                <b>Last Review Date:</b> 09/07/2023
                            </div>
                        </div>
                    </div>
                    <br />
                    <u>
                        <h2>Frequently Asked Questions</h2>
                    </u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Happens During Conception?</h3>
                            </div>
                            <div className="info-section-body">
                                Inside your ovaries every month, a group of eggs starts growing in small fluid-filled sacs called follicles. Ovulation occurs when one of the eggs bursts from the follicles, typically about two weeks before the start of your menstrual period. After the egg exits the follicle, your body releases a hormone that helps thicken the lining of your uterus in preparation to receive the egg. The egg moves through your fallopian tube where fertilization takes place. The egg remains in the fallopian tube for about 24 hours, waiting for fertilization by a single sperm.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Is Fertilization?</h3>
                            </div>
                            <div className="info-section-body">
                                After ovulation, your egg remains in the fallopian tube for 12 to 24 hours, waiting to be fertilized by one of the approximately 250 million sperm (on average) released by your partner during intercourse. When your partner releases his sperm, they travel through your cervix and into your uterus, where fertilization of the egg occurs in the fallopian tube. Only about 400 sperm out of the millions make it to the egg after a journey that takes about 10 hours, on average.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When Does Fertilization Occur?</h3>
                            </div>
                            <div className="info-section-body">
                                For fertilization to occur, sperm must reach the egg within a specific timeframe. Sperm can survive inside the female reproductive tract for up to 72 hours after ejaculation, but the egg can only survive for up to 24 hours after ovulation. If sperm reach the fallopian tube too early, they risk dying before the egg arrives. If sperm arrive at the fallopian tube too late, the egg may have already moved. Additionally, the egg is only present in one of the fallopian tubes during a specific month.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Happens When Sperm Reaches the Egg?</h3>
                            </div>
                            <div className="info-section-body">
                                Before fertilization, hundreds of sperm surround the egg as it attempts to reach the nucleus of the egg. Only one sperm will successfully penetrate the outer membrane of the egg. After the sperm penetrates the egg, an immediate chemical reaction prevents other sperm from penetrating. The chromosomes carried by the sperm and the egg then come together, officially initiating fertilization. After about a week, a ball of approximately 100 cells (called a blastocyst) reaches your uterus and is implanted into the uterine lining.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Can I Increase My Chances of Conceiving?</h3>
                            </div>
                            <div className="info-section-body">
                                When it comes to achieving pregnancy, timing is of the utmost importance. To increase your chances of conceiving, try to have intercourse at any time between 72 hours before ovulation and 24 hours after ovulation.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Can I Prepare for Pregnancy?</h3>
                            </div>
                            <div className="info-section-body">
                                The best thing you can do to prepare for pregnancy is to get your body in the best possible condition for having a child. You should stop drinking alcohol, smoking, and taking medications, including over-the-counter medications. You should inform your doctor of your plans for pregnancy and seek their advice if you need to continue taking prescription medications. At least three months before planning to try to conceive, you should start taking a multivitamin that contains at least 400 micrograms of folic acid to reduce the risk of birth defects in your child.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Will I Know I'm Pregnant Right Away?</h3>
                            </div>
                            <div className="info-section-body">
                                The pregnancy hormone (HCG), which is the hormone of pregnancy, is present in your blood following fertilization. However, pregnancy tests cannot detect HCG in your urine until after the fertilized egg has attached to the uterus during implantation. In most cases, pregnancy tests available without a prescription will not show a positive result until nine to ten days after ovulation. Most women do not experience early pregnancy symptoms until after implantation, but some may notice symptoms early on.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ConceptionCalculator;
